/* 🤖 this file was generated by svg-to-ts */
export const iconPlus: {
  name: 'plus';
  data: string;
} = {
  name: 'plus',
  data: `<!--Plus-Rounded-16--><svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M8 0c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8Zm0 2C4.691 2 2 4.691 2 8s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6Zm0 3a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2H9v1a1 1 0 1 1-2 0V9H6a1 1 0 1 1 0-2h1V6a1 1 0 0 1 1-1Z"/></svg>`,
};
